import { createSelector } from 'reselect';
import { getUpcomingDeliveriesByPrescriptionID } from '~shared/features/delivery/selectors/getUpcomingDeliveriesForPrescription';
import { getEarliestAvailableDatesByPrescriptionID } from '~shared/features/next-available-date/selectors/getEarliestAvailableDatesByPrescriptionID';
import { getPrescriptions } from '~shared/features/prescriptions/selectors/getPrescriptions';

export type AvailabilitySortData = {
  upcomingDeliveryDate: string | null;
  earliestAvailableDate: string | null;
};

// @deprecated - use libs/shared/features/prescriptions/hooks/useAvailabilityDataByPrescriptionID
export const getAvailabilityDataByPrescriptionID__DEPRECATED = createSelector(
  [getUpcomingDeliveriesByPrescriptionID, getEarliestAvailableDatesByPrescriptionID, getPrescriptions],
  (
    upcomingDeliveriesByPrescriptionID,
    earliestAvailableDatesByPrescriptionID,
    prescriptions,
  ): Record<number, AvailabilitySortData> => {
    const result: Record<number, AvailabilitySortData> = {};
    prescriptions.forEach((prescription) => {
      let upcomingDeliveryDate = null;
      if (upcomingDeliveriesByPrescriptionID[prescription.id]?.length) {
        upcomingDeliveryDate = upcomingDeliveriesByPrescriptionID[prescription.id][0].date || null;
      }

      result[prescription.id] = {
        upcomingDeliveryDate,
        earliestAvailableDate: earliestAvailableDatesByPrescriptionID[prescription.id] || null,
      };
    });
    return result;
  },
);
